module.exports = function getResource(label) {
    let resources = {
        orderSummary: 'Order Summary'
    };

    return resources[label];
};
